import styled from "styled-components";

export const ContainerBox = styled.div`
    display: flex;
    flex-direction: column;
    overflow: "hidden" .seat-content {
        display: flex;
        justify-content: center;
        overflow-x: scroll;
    }

    .container {
        margin: 50px 0;
    }

    .card {
        width: 100%;
        border: none;
    }

    .position {
        font-size: 30px;
        font-weight: 600;
    }

    .name {
        font-size: 24px;
        font-weight: 700;
        text-align: center;
    }

    .link {
        font-size: 24px;
        font-weight: 500;
        font-style: normal;
    }

    .id {
        font-size: 30px;
        font-weight: 500;
        font-style: normal;
    }

    .footer {
        position: absolute;
        bottom: 10;
        max-width: 95%;
    }

    .row {
        display: flex;
        justify-content: space-between;
    }

    .info {
        font-size: 18px;
        font-weight: 500;
        font-style: normal;
        text-align: justify;

        .company {
            font-size: 16px;
            font-style: italic;
        }

        .role {
            font-weight: 600;
        }
    }
`;

export const Content = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    flex-grow: 1;
`;

export const Row = styled.div`
    background: rgba(239, 239, 239, 0.8);
    -webkit-box-shadow: 0 0 10px -3px rgb(0, 0, 0);
    -moz-box-shadow: 0 0 10px -3px rgb(0, 0, 0);
    box-shadow: 0 0 10px -3px rgb(0, 0, 0);
    border-radius: 1.5%;
    display: flex;
    align-items: center;
    flex-direction: row;
`;

export const Align = styled.div`
    width: 100%;
    display: inline-flex;
    position: relative;
    align-items: center;
`;

export const LogoName = styled.span`
    font-family: "Roboto";
    font-size: 26px;
    line-height: 30px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    flex-grow: 1;

    color: #fff;

    opacity: 0.6;
`;

export const Header = styled.div`
    overflow: hidden;
    background: linear-gradient(115.6deg, #0a9e9e 0%, #175d90 59.58%, #733bb9 100%);
    padding: 20px 10px;
`;
